import { CallTakerStationOption } from '@mark43/cad-api';
import React from 'react';

export type CallTakerStationContextValue = {
    setCurrentStation: React.Dispatch<CallTakerStationOption | undefined> | undefined;
    currentStation: CallTakerStationOption | undefined;
    assignCallTakerStationElectron: ((stationId?: number) => void) | undefined;
    registerAssignCallTakerStationElectronFailedHandler:
        | ((handler: (() => void) | null) => void)
        | undefined;
};

export const CallTakerStationContext = React.createContext<CallTakerStationContextValue>({
    currentStation: undefined,
    setCurrentStation: undefined,
    assignCallTakerStationElectron: undefined,
    registerAssignCallTakerStationElectronFailedHandler: undefined,
});
